import App from './index.svelte';

const app = new App({
    target: document.body
});

export default app;
